export { default } from '@/screens/ProfileScreen';

